<div class="row text-black">
  @if (selectedRisk) {
    <div class="col-md-6">
      @for (risk of risks; track risk) {
        <div class="py-3 font-size-smaller" [class.text-primary]="selectedRisk.id == risk.id">
          <span class="cursor-pointer" (click)="selectRisk(risk)">
            {{ risk.title }}
            @if (selectedRisk.id == risk.id) {
              <i class="pl-3 fa fa-angle-right"></i>
            }
          </span>
        </div>
      }
    </div>
  }
  <div class="col-md-6">
    <div class="description">
      @if (selectedRisk) {
        <div class="ck-content" [innerHTML]="selectedRisk.description | trustSrc"></div>
      }
    </div>
  </div>
</div>
